export default __webpack_public_path__ + "static/media/export.0c42f244.svg";